import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

import Maximize from './maximize.svg';
import { CLOSE_ON_ESCAPE, CLOSE_ON_CLICK } from './config';

import './style.css';

export default class LSFullScreen extends Plugin {
  static get pluginName() {
    return 'LSFullScreen';
  }

  // constructeur de la classe LSFullScreen
  constructor(editor) {
    super(editor);
    this.set('isFullScreen', false);
    this.styles = {};
  }
  // on initialise le plugin
  init() {
    // on récupère l'objet editor de l'éditeur
    const editor = this.editor;
    // on récupère l'objet t de l'éditeur qui permet de traduire les chaines de caractères
    const t = editor.t;

    // on se place dans le root de l'éditeur pour pouvoir modifier les styles de l'éditeur
    const rootElement = editor.editing.view.document.getRoot();

    // on initialise les propriétés closeOnEscape et closeOnClick par défaut à true
    editor.config.define( CLOSE_ON_ESCAPE, true );
    editor.config.define( CLOSE_ON_CLICK, false );

    // on crée une fonction pour modifier les styles de l'éditeur
    const maximize = () => {

      const wrapperElement = editor.ui.view.element;
      
      // On passe un focus à la div générale pour qu'elle puisse capturer les pressions sur les touches
      // L'attribut tabindex spécifie si un élément peut être ciblé (focus) en utilisant la navigation au clavier.
      wrapperElement.setAttribute('tabindex', '0');
      // On applique les styles
      wrapperElement.classList.add('ck-plugin-full-screen');
      this.styles = {
        'height': rootElement.getStyle('height'),
        'overflow-y': rootElement.getStyle('overflow-y'),
      };
      // Les changements de style dynamiques de l'élément racine ckeditor doivent être effectués sur le writer
      editor.editing.view.change(writer => {
        writer.setStyle({'height': '100%', 'overflow-y': 'scroll'}, rootElement);
      });
    };

    // on crée une fonction pour restaurer les styles de l'éditeur
    const minimize = () => {

      const wrapperElement = editor.ui.view.element;

      wrapperElement.removeAttribute('tabindex');
      wrapperElement.classList.remove('ck-plugin-full-screen');
      editor.editing.view.change(writer => {

        this._restoreStyles(writer, rootElement);

      });
    };

    // on ajoute le bouton fullscreen à la toolbar
    editor.ui.componentFactory.add('fullscreen', () => {
      
      const wrapperElement = editor.ui.view.element;
      
      // on crée un bouton
      const button = new ButtonView();
      
      button.set({

        label: t('Afficher l\'éditeur en plein écran'), // on traduit le label du bouton en fonction de la langue de l'éditeur (optionnel)
        icon: Maximize,
        tooltip: true,

      });

      // Faire apparaître le bouton de la barre d'outils cliqué lorsque le plein écran est actif
      button.bind('isOn').to(this, 'isFullScreen');

      const closeOnEscape = editor.config.get( CLOSE_ON_ESCAPE );
      const closeOnClick = editor.config.get( CLOSE_ON_CLICK );

      // On ferme le plein écran avec la touche Echap
      const onKeyDown = e => {

        if (e.key === 'Escape' && this.isFullScreen) {
          button.fire('execute');
          e.stopPropagation();
        }

      };

      // On ferme le plein écran au clic en dehors de l'éditeur
      const onClick = e => {

        if (e.target === e.currentTarget && this.isFullScreen) {
          button.fire('execute');
          e.stopPropagation();
        }

      };

      // Action au clic sur le bouton fullscreen de la toolbar
      button.on('execute', () => {
       
        if (!this.isFullScreen) {
          closeOnEscape && wrapperElement.addEventListener('keydown', onKeyDown);
          closeOnClick && wrapperElement.addEventListener('click', onClick);

          maximize();

        } else {
          closeOnEscape && wrapperElement.removeEventListener('keydown', onKeyDown);
          closeOnClick && wrapperElement.removeEventListener('click', onClick);

          minimize();

        }
        // On inverse la valeur de la propriété isFullScreen
        this.isFullScreen = !this.isFullScreen;
        // On met le focus sur l'éditeur
        editor.editing.view.focus();
      });

      return button;

    });
  }

  // on restaure les styles en passant en paramètre le writer, le nom du style, la valeur du style et l'élément
  _restoreStyle(writer, name, value, element) {
    value !== undefined ? writer.setStyle(name, value, element) : writer.removeStyle(name, element);
  }

  // on restaure tout les styles en passant en paramètre le writer, l'élément
  _restoreStyles(writer, element) {
    this._restoreStyle(writer, 'height', this.styles.height, element);
    this._restoreStyle(writer, 'overflow-y', this.styles['overflow-y'], element);
  }
}